<template>

  <td>
    {{ $e("Batterie")}} :
  </td>

  <td>
    <template v-if="!DroneIsCharging">
      <span class="">
        {{ Batt1 }}%
        <span class="ml-1 mr-3">({{ TempBatt1 }}°C)</span>
      </span>

      <span class="" v-if="Batt2 != false">
        {{ Batt2 }}%
        <span class="ml-1 mr-3">({{ TempBatt2 }}°C)</span>
      </span>
    </template>
    <template v-else>
      <span class="">
        {{ ChargingBatt }}%
      </span>
    </template>
  </td>

  <td>
    <template v-if="!DroneIsCharging">
      <template v-if="Batt2 != false">
        <div v-if="Batt1 >= 50 && Batt2 >= 50" v-html="cheack.ok"></div>
        <div v-else-if="Batt1 >= 30 && Batt2 >= 30" v-html="cheack.warning"></div>
        <div v-else v-html="cheack.nok"></div>
      </template>
      <template v-else>
        <div v-if="Batt1 >= 50" v-html="cheack.ok"></div>
        <div v-else-if="Batt1 >= 30" v-html="cheack.warning"></div>
        <div v-else v-html="cheack.nok"></div>
      </template>
    </template>
    <template v-else>
      <div v-if="ChargingBatt >= 50" v-html="cheack.ok"></div>
      <div v-else-if="ChargingBatt >= 30" v-html="cheack.warning"></div>
      <div v-else v-html="cheack.nok"></div>
    </template>
  </td>
</template>

<script>
export default {
  props: {
    config: Object,
    cheack: Object,
  },
  computed: {
    DroneIsCharging() {
      return this.config?.dock?.status?.drone_charge_state?.state != undefined
        ? this.config.dock.status.drone_charge_state.state == 1
        : false;
    },

    ChargingBatt() {
      return this.config?.dock?.status?.drone_charge_state?.capacity_percent != undefined
        ? this.config?.dock?.status?.drone_charge_state?.capacity_percent
        : ENV.NO_DATA;
    },

    Batt1() {
      return this.config?.drone?.status?.battery?.batteries[0]?.capacity_percent != undefined
        ? this.config.drone.status.battery.batteries[0].capacity_percent
        : ENV.NO_DATA;
    },

    TempBatt1() {
      return this.config?.drone?.status?.battery?.batteries[0]?.temperature != undefined
        ? this.config.drone.status.battery.batteries[0].temperature
        : ENV.NO_DATA;
    },

    Batt2() {
      return this.config?.drone?.status?.battery?.batteries[1]?.capacity_percent != undefined
        ? this.config.drone.status.battery.batteries[1].capacity_percent
        : false;
    },

    TempBatt2() {
      return this.config?.drone?.status?.battery?.batteries[1]?.temperature != undefined
        ? this.config.drone.status.battery.batteries[1].temperature
        : false;
    },

  },
};
</script>
